<template><CatalogManager type="categories" title="Categorías" /></template>
<script>import CatalogManager from '../components/catalog-manager.vue'; export default { components:{ CatalogManager } };</script>
